angular
  .module('fca-used')
  .component('home', {
    templateUrl: 'app/home/home.html',
    controller: homeController,
    controllerAs: 'home'
  });

homeController.$inject = ['$element', '$window', 'debounce', 'wishlist', 'tagging', 'scroll', 'BREAKPOINTS', 'CONFIG'];

function homeController($element, $window, debounce, wishlist, tagging, scroll, BREAKPOINTS, CONFIG) {
  var home = this;

  home.wishlist = wishlist;
  if (CONFIG.mirafioriStripe && CONFIG.mirafioriStripe.selector) {
    var target = $window.document.querySelector(CONFIG.mirafioriStripe.selector);
    if (target) {
      target.style.display = 'block';
    }
  }

  home.$onInit = function () {
    home.scroll = scroll;
    tagging.track({
      page: 'used'
    });
  };

  // function resize() {
  //   var height = $window.innerHeight - home.container.offsetTop;
  //   home.container.style.minHeight = height + 'px';
  // }

  // if ($window.innerWidth <= BREAKPOINTS.PHONE_PORTRAIT.MAX) {
  //   var resizeDebounced = debounce(resize, 200);

  //   $window.onResize = resize;

  //   home.$onInit = function () {
  //     home.scroll = scroll;
  //     home.container = $element.find('section')[0];
  //     resize();
  //     $window.addEventListener('resize', resizeDebounced);
  //   };

  //   home.$onDestroy = function () {
  //     $window.removeEventListener('resize', resizeDebounced);
  //   };
  // }
}
